{
  "title": "Charm Monster",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "4th-level enchantment",
  "level": 4,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S",
  "duration": "1 hour",
  "description": [
    "You attempt to charm a creature you can see within range. It must make a Wisdom saving throw, and it does so with advantage if you or your companions are fighting it. If it fails the saving throw, it is charmed by you until the spell ends or until you or your companions do anything harmful to it. The charmed creature is friendly to you. When the spell ends, the creature knows it was charmed by you.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, you can target one additional creature for each slot level above 4th. The creatures must be within 30 feet of each other when you target them."
  ],
  "spellLists": ["bard", "druid", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
